<div class="tw-flex tw-flex-row" style="height: 100%;">
    <div class="tw-w-full">
        <mat-tab-group color="primary" animationDuration="0ms" style="height: 100%;" [selectedIndex]="getTabChange" 
            [class.no-selection]="getTabChange === -1"
            (selectedTabChange)="tabPanelChange.emit($event.tab.textLabel)"
        >
            <mat-tab label="{{'ITEMS.TOPBAR_ITEMS.PRODUCTS' | translate}}"><ng-content select="[Products]"></ng-content></mat-tab>
            <mat-tab label="{{'ITEMS.TOPBAR_ITEMS.CATEGORIES' | translate}}"><ng-content select="[Categories]"></ng-content></mat-tab>
            <mat-tab label="{{'ITEMS.TOPBAR_ITEMS.COMPONENTS' | translate}}"><ng-content select="[Components]"></ng-content></mat-tab>
            <mat-tab label="{{'ITEMS.TOPBAR_ITEMS.RAW_MATERIALS' | translate}}"><ng-content select="[RawMaterials]"></ng-content></mat-tab>
            <mat-tab label="{{'ITEMS.TOPBAR_ITEMS.DEPARTMENTS' | translate}}"><ng-content select="[Departments]"></ng-content></mat-tab>
            <mat-tab label="{{'ITEMS.TOPBAR_ITEMS.VAT_RATE' | translate}}"><ng-content select="[VatRate]"></ng-content></mat-tab>
        </mat-tab-group>
    </div>
</div>
